export default class CalibrationModalController {
  /* @ngInject*/
  constructor($uibModalInstance, Modal) {
    // Assign injected values to scope
    this.Modal = Modal;
    this.$uibModalInstance = $uibModalInstance;
  }

  closeModal() {
    this.$uibModalInstance.close();
  }

}



// WEBPACK FOOTER //
// ./client/components/modal/info/modal.component.js